import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "@fortawesome/fontawesome-svg-core/styles.css";
import {
  faBorderAll,
  faMap,
  faRectangleList,
} from "@fortawesome/free-solid-svg-icons";
import { useAtom } from "jotai";
import { filtersAtomObject, originalDataAtomObject } from "../../state";

const ResultsHeader = ({ toggleMap, toggleGridView, showMap }) => {
  const { t } = useTranslation();
  const [isView, setIsView] = useState();
  const [originalData] = useAtom(originalDataAtomObject);
  const [filters] = useAtom(filtersAtomObject);

  const { spelling, totalCount, jobs } = originalData;
  const loadCount = jobs.length;
  const { location, query } = filters;

  return (
    <>
      <div className="results-header">
        <Row>
          <Col>
            <h2 className="xs-heading">
              {t("showing")} {loadCount} {t("of")} {totalCount} {t("results")}{" "}
              {query ? t("for") : ""}{" "}
              <strong> {spelling ? spelling : query}</strong>{" "}
              {location && (
                <span>
                  {t("in")} <span>{location}</span>
                </span>
              )}
              {spelling && (
                <span className="instead">
                  {t("spelling")
                    .replace("MISSPELLED_KEYWORD", query)
                    .replace("CORRECT_KEYWORD", spelling)}
                </span>
              )}
            </h2>
          </Col>
          <Col xs={"auto"}>
            <div
              className="btn desktop-btn"
              id="toggleViewBtn"
              onClick={() => {
                toggleGridView();
                setIsView(!isView);
              }}
            >
              <span>
                <FontAwesomeIcon
                  icon={!isView ? faBorderAll : faRectangleList}
                />
                {!isView ? t("grid_view") : t("list_view")}{" "}
              </span>
            </div>
            {showMap && (
              <div className="btn" id="mapBtn" onClick={toggleMap}>
                <span>
                  <FontAwesomeIcon icon={faMap} /> {t("map_view")}
                </span>
              </div>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ResultsHeader;
